import { CameraService } from './camera.service';

export default angular
  .module('sfMobile.services.camera', [])
  .service('cameraService', CameraService).name;
